// Modules
import { apartmentSliderInit } from './modules/apartment-slider';
import { historyPriceModalInit } from './modules/history-price-modal';
import { imgMapObjectStatuseslInit } from './modules/image-map-statuses';


window.addEventListener('DOMContentLoaded', () => {
  apartmentSliderInit();
  historyPriceModalInit();
  // imgMapObjectStatuseslInit();
});